import { slugify } from '@realadvisor/transform/slugify';

// The agent profile URL slug a first publication sets when the agent has none
// yet: their slugified full name, at most 81 characters.
export const generateAgentSlug = (
  firstName: string | null,
  lastName: string | null,
) => {
  const fullName = [firstName, lastName].filter(Boolean).join(' ');
  if (!fullName) {
    return null;
  }

  const slug = slugify(fullName);

  if (!slug || !/^[a-z0-9]/.test(slug)) {
    return null;
  }

  return slug.slice(0, 81).replace(/-$/, '');
};
